import React, { useState } from 'react';
import { Image, StyleSheet, View } from 'react-native';

import { AppRouter } from './Navigation';
import MainNav from './App/MainNav';
import UserNav from './App/UserNav';
import AppAlert from './App/AppAlert';
import { PasswordChangeDialog } from './App/PasswordDialog';
import { AppDialog } from './App/AppDialog';
import UpdateAlert from './App/UpdateAlert';
import ViewingSeason from './App/ViewingSeason';
import ReleaseNotesModal from './ReleaseNotesModal';
import CommandPalette from './CommandPalette';
import { useAuthState } from './AuthState';
import { sizes, themeColors } from './uiold/Constants';
import { HiddenPrintView } from './uiold/HiddenPrintView';

export default function App() {
  const [showPasswordChangeDialog, setShowPasswordChangeDialog] = useState(
    false,
  );

  const { account, user } = useAuthState();

  return (
    <View style={styles.root}>
      <ReleaseNotesModal />
      <HiddenPrintView style={styles.pageHeader}>
        <Image
          style={styles.logoTop}
          source={{ uri: '/assets/images/logo-wide.svg' }}
          accessibilityLabel={t('MarketWurks Logo')}
        />
        <ViewingSeason account={account} />
        <UserNav
          account={account}
          onChangePasswordPress={() => setShowPasswordChangeDialog(true)}
          user={user}
        />
      </HiddenPrintView>
      <View style={styles.rowFlexed}>
        <MainNav />
        <View style={styles.pageContainer}>
          <AppRouter />
        </View>
      </View>
      <AppAlert />
      <AppDialog />
      <PasswordChangeDialog
        isOpen={showPasswordChangeDialog}
        onClosePress={() => setShowPasswordChangeDialog(false)}
        user={user}
      />
      <UpdateAlert />
      <CommandPalette />
    </View>
  );
}

let styles = StyleSheet.create({
  root: {
    flex: 1,
  },
  pageHeader: {
    flexDirection: 'row',
    backgroundColor: themeColors.white,
    justifyContent: 'flex-end',
    alignItems: 'center',
    paddingHorizontal: 30,
    height: sizes.headerHeight,
    maxHeight: sizes.headerHeight,
    zIndex: 1,
  },
  rowFlexed: {
    flex: 1,
    flexDirection: 'row',
  },
  logoTop: {
    position: 'absolute',
    left: 30,
    width: 253,
    height: 40,
  },
  pageContainer: {
    flex: 1,
  },
});
